import { api } from './client';
import type { OutfitGroup, OutfitPiece } from '../types';

/** Pieces and groups travel together: a day renders both at once. */
export interface OutfitPlan {
  pieces: OutfitPiece[];
  groups: OutfitGroup[];
}

export const outfitsApi = {
  list: (tripId: string) => api.get<OutfitPlan>(`/trips/${tripId}/outfits`).then(r => r.data),

  addPiece: (tripId: string, data: { dayId: string; checklistItemId: string; groupId?: string | null }) =>
    api.post<OutfitPiece>(`/trips/${tripId}/outfits/pieces`, data).then(r => r.data),
  movePiece: (tripId: string, pieceId: string, groupId: string | null) =>
    api.patch<OutfitPiece>(`/trips/${tripId}/outfits/pieces/${pieceId}`, { groupId }).then(r => r.data),
  removePiece: (tripId: string, pieceId: string) => api.delete(`/trips/${tripId}/outfits/pieces/${pieceId}`),

  createGroup: (tripId: string, data: { dayId: string; title: string }) =>
    api.post<OutfitGroup>(`/trips/${tripId}/outfits/groups`, data).then(r => r.data),
  renameGroup: (tripId: string, groupId: string, title: string) =>
    api.patch<OutfitGroup>(`/trips/${tripId}/outfits/groups/${groupId}`, { title }).then(r => r.data),
  deleteGroup: (tripId: string, groupId: string) => api.delete(`/trips/${tripId}/outfits/groups/${groupId}`),
};
